import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { newsletterTemplateImagesEdit_template } from "../components/templates/newsletterTemplateImagesEdit_template";
import { vn_app_zone_notification } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import { header } from "./header";

declare var ko: any;
declare var page: any;

export class newsletter_template_images_edit extends vnModule_knockoutJS{
    protected newsletterTemplateImagesEdit!: newsletterTemplateImagesEdit_template
    protected XHRHdl!: XMLHttpRequestHandler;
    protected _isLeavePageWarningNeeded: boolean = true;

    buildContent(): Array<Element> {
        this.newsletterTemplateImagesEdit = new newsletterTemplateImagesEdit_template('newsletterTemplateImagesEdit', this.viewModel, this)
        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader!.loadedModule;
        (<header>loadedModule).setHeaderTitle("Newsletter Header Image");
        return [this.newsletterTemplateImagesEdit.build()]
    }

    protected getModuleName(): string {
        return "newsletter_template_images_edit";
    }

    public fillPage() {
        // A stored image is shown as a preview instead of the drop zone, so the uploader is only
        // built when a new one is being added.
        if (this.getVnAppZone().app.params.id) {
            this.getHeaderImageData();
            return;
        }

        this.newsletterTemplateImagesEdit.generateDropzone(this.getVnAppZone().app.params.idBrand);
    }

    private getHeaderImageData() {
        let id = this.getVnAppZone().app.params.id;
        if (!id) {
            return;
        }

        this.loadingIn(this.newsletterTemplateImagesEdit.builtTemplate);

        let idBrand = this.getVnAppZone().app.params.idBrand;
        let url : string = '/api/brand/' + idBrand + '/newsletter/templates/images/get/' + id + '/';
        let request_parameters : Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(url, request_parameters, this);
        this.XHRHdl.onReadyStateFunction = this.onGetHeaderImageDataReturn;
        this.XHRHdl.execute();
    }

    private onGetHeaderImageDataReturn(req: any, obj: any) {
        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);
                obj.newsletterTemplateImagesEdit.setHeaderImage(responseParsed.data)

            });
            obj.loadingOut(obj.newsletterTemplateImagesEdit.builtTemplate);
        }
    }

    public onClickCancelEdit(){
        let brandId = this.getVnAppZone().app.params.idBrand
        page.redirect("/brand/" + brandId + "/newsletter/templates/images/")
    }

    protected save() {
        this.validationTemplate.clearMessages();

        let subViewModel = this.newsletterTemplateImagesEdit.getViewModelForRequest();

        let validationMessages = this.getValidationMessages(subViewModel);
        if (validationMessages.length > 0) {
            this.validationTemplate.setMessages(validationMessages);
            window.scrollTo(0, 0);
            return;
        }

        this.loadingIn(this.newsletterTemplateImagesEdit.builtTemplate);

        let idBrand = this.getVnAppZone().getApp().params.idBrand;

        let formReq_url: string = '/api/brand/' + idBrand + "/newsletter/templates/images/save/";
        let formReq_params: Array<Array<string>> = [];

        formReq_params.push(["data", ko.toJSON(subViewModel)]);

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function (req: any, obj: any) {

            return function () {

                obj.manageResponse(req, obj, function () {

                    page.redirect('/brand/' + idBrand + "/newsletter/templates/images/");

                    if (req.request.status === 200) {
                        obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Header Image saved !");
                    }
                });
                obj.loadingOut(obj.newsletterTemplateImagesEdit.builtTemplate);
            }
        });
        XHRHdl.execute();
    }

    public onHeaderImageUploadError(response: any) {
        if (response && response.validations) {
            this.validationTemplate.setMessages(response.validations);
            window.scrollTo(0, 0);
        }
    }

    private getValidationMessages(data: any): any[] {
        let errors = [];
        let width = String(data.width || '').trim();
        let height = String(data.height || '').trim();

        if (!data.name) {
            errors.push({field: "Name", label: "Name", messages: ["Name cannot be empty."]});
        }

        if (!data.image) {
            errors.push({field: "Image", label: "Image", messages: ["Image cannot be empty."]});
        }

        if (!width && !height) {
            errors.push({field: "Width", label: "Width or Height", messages: ["Width or Height is required."]});
        }

        if (width && height) {
            errors.push({field: "Width", label: "Width or Height", messages: ["Width and Height cannot both be entered."]});
        }

        if (width && (!/^[1-9][0-9]*$/.test(width))) {
            errors.push({field: "Width", label: "Width", messages: ["Width must be a positive integer."]});
        }

        if (height && (!/^[1-9][0-9]*$/.test(height))) {
            errors.push({field: "Height", label: "Height", messages: ["Height must be a positive integer."]});
        }

        return errors;
    }
}



// WEBPACK FOOTER //
// ./js/modules/newsletter_template_images_edit.ts